import styled from "styled-components";

import Button from "Utilities/Button";
import useWizard from "./useWizard";

export default function WizardNavigation() {
  const {
    currentStep,
    currentSubStep,
    steps,
    nextSubStep,
    prevSubStep,
    goToStep,
    isCurrentStepValid,
    modalOpen,
  } = useWizard();

  const isFirstStep = currentStep === 1 && currentSubStep === 0;
  const isLastStep = currentStep === steps.length;
  const stepDef = steps.find((s) => s.id === currentStep);
  const hideNext = stepDef?.hideNext?.includes(currentSubStep);

  // Hide entire nav during loading and complete screens
  if (isLastStep && currentSubStep >= 1) return null;

  return (
    <Footer>
      <Left>
        {!isFirstStep && (
          <NavButton onClick={prevSubStep} tabIndex={-1}>
            <span><BackIcon className="fas fa-circle-chevron-left" /> Back</span>
          </NavButton>
        )}
      </Left>
      <Right>
        {isLastStep ? (
          <Button onClick={() => goToStep(5, 1)}>
            Finalize <NavIcon className="fas fa-circle-check" />
          </Button>
        ) : !hideNext ? (
          <Button onClick={nextSubStep} disabled={!isCurrentStepValid || modalOpen}>
            Next <NavIcon className="fas fa-circle-chevron-right" />
          </Button>
        ) : null}
      </Right>
    </Footer>
  );
}

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 40px;
  height: 90px;
  box-sizing: border-box;
  border-top: 1px solid #e5e7eb;
`;

const Left = styled.div``;
const Right = styled.div``;

const NavButton = styled.button`
  appearance: none;
  border: none;
  background: none;
  font-size: 15px;
  color: #6b7280;
  cursor: pointer;
  padding: 8px 10px 8px 8px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: inherit;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: #e5e7eb;
    color: #016099;
  }

  > span {
    display: flex;
    align-items: center;
    gap: 4px;
    transition: transform 0.2s;
  }

  &:active {
    background: #016099;
    color: #fff;

    > span {
      transform: scale(0.85);
    }
  }
`;

const BackIcon = styled.i`
  font-size: 1em;
  margin-right: 2px;
`;

const NavIcon = styled.i`
  font-size: 0.85em;
  position: relative;
  top: -1px;
  margin: 0 4px;
`;

